import {
    Component,
    Host,
    h,
    Prop,
    Element,
    State,
    Watch,
    Event,
    EventEmitter,
} from "@stencil/core";
import api from "../../../utils/api";
import { ToolboxResponse } from "./toolbox-response";

@Component({
    tag: "ux-iws-meta-navigation-toolbox",
    styleUrl: "navigation-toolbox.scss",
    shadow: false,
})
export class MetaNavigationToolbox {
    private baseClass = "ux-iws-meta-navigation-toolbox";
    private toolbox!: HTMLDivElement;

    @Element() domNode: HTMLUxIwsMetaNavigationToolboxElement;
    /** the url from wich the content of the box needs to be fetched */
    @Prop() url: string;
    /** if prop active is true = load the content */
    @Prop() active: boolean = false;
    /** has error */
    @State() hasError: boolean = false;

    /** event emitted when the loaded content is inserted in the box */
    @Event({
        eventName: "uxToolboxLoaded",
        composed: false,
        cancelable: false,
        bubbles: true,
    })
    toolboxLoaded: EventEmitter;

    @Watch("active")
    loadContent() {
        if (this.active) this.loadBoxContent();
    }

    private async loadBoxContent() {
        await this.setBoxContent();
    }

    private setBoxContent = async () => {
        try {
            if (isMockUrl(this.url))
                await new Promise((resolve) => setTimeout(resolve, 2000));
            const response = await api<ToolboxResponse>(this.url);
            if (response.status === "success") {
                if (response.data.length > 0) {
                    this.toolbox.innerHTML = "";
                    this.toolbox.insertAdjacentHTML(
                        "afterbegin",
                        response.data.join("")
                    );
                    this.toolboxLoaded.emit({ success: true });
                } else {
                    this.toolboxLoaded.emit({ success: false });
                }
            } else if (response.status === "invalid") {
                this.toolbox.innerHTML = "";
                this.toolboxLoaded.emit({ success: false });
            }
        } catch (e) {
            console.log(e);
            this.hasError = true;
            this.toolbox.innerHTML = "";
            this.toolboxLoaded.emit({ success: false });
        }
    };

    render() {
        return (
            <Host class={this.baseClass}>
                <div
                    class={`${this.baseClass}__inner`}
                    ref={(el) => (this.toolbox = el as HTMLDivElement)}
                >
                    <ux-loader variant="spinner"></ux-loader>
                </div>
            </Host>
        );
    }
}

function isMockUrl(url: string) {
    return url.indexOf("mock-data/") > -1;
}
